import React from 'react'
import _ from 'lodash'
export default class Calculos extends React.Component{
  constructor (props) {
      super (props)
    }
    render () {
      var e = ()=> {return 'e'+Math.random()}
      var tr = []
      let tdsFunction = function(d){
        let tds2 = []
        let tds = []
        _.map(d,(n,i)=>{
            // console.log(i,n)
            if(!_.isObject(n)){
             tds.push(<td key={e()}>{i}</td>)
             tds2.push(<td key={e()}>{n}</td>)
            }
            else{
              tdsFunction(n)
            }
        })

        tr.push(<tr key={e()}>{tds}</tr>)
        tr.push(<tr key={e()}>{tds2}</tr>)
      }
      tdsFunction(this.props.data)

      return (
        <div className="widthAndScroll">
          <h3>Tabla de Calculos</h3>
          <table className="calTable">
          <tbody>
            {tr}
          </tbody>
          </table>
        </div>
      )
    }
}



// WEBPACK FOOTER //
// ./src/components/Patient/Calculos.js